export default "__VITE_ASSET__DgbascLb__"